// extracted by mini-css-extract-plugin
module.exports = {"light":"ImageBlock_light__t7ZAq","dark":"ImageBlock_dark__dZkUr","wrapper":"ImageBlock_wrapper__4R50B","container":"ImageBlock_container__B7VWS"};